/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pw_faq_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequently asked questions`)
};

const es_pw_faq_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntas frecuentes`)
};

const de_pw_faq_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Häufig gestellte Fragen`)
};

const nl_pw_faq_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veelgestelde vragen`)
};

const fr_pw_faq_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions fréquemment posées`)
};

const it_pw_faq_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domande frequenti`)
};

const pt_br2_pw_faq_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perguntas frequentes`)
};

const pt_pw_faq_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perguntas frequentes`)
};

const ja_pw_faq_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`よくある質問`)
};

const zh_pw_faq_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`常见问题`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pw_faq_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pw_faq_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pw_faq_title", locale)
	if (locale === "en") return en_pw_faq_title(inputs)
	if (locale === "es") return es_pw_faq_title(inputs)
	if (locale === "de") return de_pw_faq_title(inputs)
	if (locale === "nl") return nl_pw_faq_title(inputs)
	if (locale === "fr") return fr_pw_faq_title(inputs)
	if (locale === "it") return it_pw_faq_title(inputs)
	if (locale === "pt-BR") return pt_br2_pw_faq_title(inputs)
	if (locale === "pt") return pt_pw_faq_title(inputs)
	if (locale === "ja") return ja_pw_faq_title(inputs)
	return zh_pw_faq_title(inputs)
};